import { default as getCardDetailsConfiguration } from './getCardDetails';
import { default as getPlansConfiguration } from './getPlans';
import { default as getCouponConfiguration } from './getCoupon';
import { default as getSubscriptionConfiguration } from './getStripeSubscription';
import { default as getBusinessSubscriptionConfiguration } from './getBusinessStripeSubscription';
import { default as getUpComingInvoiceConfiguration } from './getUpcomingInvoice';
import { default as getBusinessUpcomingInvoiceConfiguration } from './getBusinessUpcomingInvoice';

export const configurations = [
  getPlansConfiguration,
  getCardDetailsConfiguration,
  getCouponConfiguration,
  getSubscriptionConfiguration,
  getBusinessSubscriptionConfiguration,
  getUpComingInvoiceConfiguration,
  getBusinessUpcomingInvoiceConfiguration,
];


// WEBPACK FOOTER //
// ./src/state/modules/payment/configurations/index.js